<!-- 租控图 -->
<template>
  <div class="rent-control-container tab-root">
    <!-- 顶部页签 -->
    <div class="tabs-header">
      <el-button-group>
        <el-button
          v-for="tab in tabs"
          :key="tab"
          :type="activeTab === tab ? 'primary' : ''"
          size="small"
          @click="tabClick(tab)"
        >
          {{ tab }}
        </el-button>
      </el-button-group>
    </div>
    <!-- 楼宇租控 -->
    <leaseControlMapTab1 v-if="activeTab == '楼宇租控'" />
    <leaseControlMapTab2 v-if="activeTab == '车位租控'" />
    <leaseControlMapTab3 v-if="activeTab == '广告位租控'" />
    <leaseControlMapTab4 v-if="activeTab == '保租房租控'" />
    <leaseControlMapTab5 v-if="activeTab == '铺位租控'" />
  </div>
</template>

<script>
import leaseControlMapTab1 from "./components/leaseControlMapTab1.vue";
import leaseControlMapTab2 from "./components/leaseControlMapTab2.vue";
import leaseControlMapTab3 from "./components/leaseControlMapTab3.vue";
import leaseControlMapTab4 from "./components/leaseControlMapTab4.vue";
import leaseControlMapTab5 from "./components/leaseControlMapTab5.vue";

import { mapState, mapActions, mapMutations } from "vuex";

export default {
  components: {
    leaseControlMapTab1, // 楼宇租控
    leaseControlMapTab2, // 车位租控
    leaseControlMapTab3, // 广告位租控
    leaseControlMapTab4, // 保租房租控
    leaseControlMapTab5, // 铺位租控
  },
  name: "RentControlMap",
  data() {
    return {
      activeTab: "楼宇租控",
      // 页签数据
      tabs: ["楼宇租控", "车位租控", "广告位租控", "保租房租控", "铺位租控"],
    };
  },
  mounted() {
    console.log("租控图组件已加载");
  },
  methods: {
    ...mapMutations("asset", ["CLEAR_ALL_RENT_LIST"]),

    tabClick(tab) {
      this.activeTab = tab;
      this.CLEAR_ALL_RENT_LIST();
    },
  },
};
</script>

<style lang="scss" scoped>
/* 颜色变量定义 */
$bg-main: #f0f2f5; // 页面主背景
$color-rented: #52c41a; // 已出租 (绿色)
$color-vacant: #ffffff; // 空置 (白色)
$color-reserved: #1890ff; // 已预订 (蓝色)
$color-decorating: #722ed1; // 装修中 (紫色)
$color-expiring: #f5222d; // 即将到期 (红色)
$border-light: #ebeef5; // 浅边框色
$text-secondary: #909399; // 次要文字颜色

.tab-root {
  padding: 16px;
  background-color: $bg-main;
}
.rent-control-container {
  // padding: 16px;
  // background-color: $bg-main;
  min-height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial;

  /* 顶部页签 */
  .tabs-header {
    margin-bottom: 16px;
    text-align: left;
  }

  /* 统计行布局 */
  .stats-row {
    display: flex;
    gap: 12px;
    margin-bottom: 20px;
    flex-wrap: wrap;

    .stat-card {
      flex: 1;
      min-width: 160px;
      background: #fff;
      padding: 12px 20px;
      border-radius: 4px;
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);

      .stat-label {
        color: $text-secondary;
        font-size: 13px;
        margin-bottom: 8px;
      }
      .stat-value {
        font-size: 22px;
        font-weight: 500;
        .unit {
          font-size: 14px;
          margin-left: 4px;
        }
      }
    }
  }

  /* 筛选工具栏 */
  .filter-bar {
    background: #fff;
    padding: 12px 20px;
    border-radius: 4px 4px 0 0;
    border-bottom: 1px solid $border-light;
    .filter-label {
      font-size: 14px;
      color: #303133;
    }
  }

  /* 图例栏 */
  .legend-bar {
    background: #fff;
    padding: 10px 20px;
    display: flex;
    align-items: center;
    gap: 15px;
    font-size: 13px;
    border-bottom: 1px solid $border-light;

    .legend-title {
      font-weight: bold;
    }
    .legend-item {
      display: flex;
      align-items: center;
      .legend-color {
        width: 14px;
        height: 14px;
        display: inline-block;
        margin-right: 6px;
        border-radius: 2px;
      }
    }
  }

  /* 单元区块 */
  .unit-section {
    margin-top: 16px;
    background: #fff;
    border-radius: 4px;
    overflow: hidden;

    .unit-header {
      background: #f8f9fb;
      padding: 10px 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      font-size: 14px;
      font-weight: bold;
      border-bottom: 1px solid $border-light;
    }

    .unit-content {
      padding: 15px;
    }
  }

  /* 楼层行布局 */
  .floor-row {
    display: flex;
    margin-bottom: 10px;
    align-items: stretch;

    .floor-label {
      width: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      color: #606266;
      background: #fafafa;
      border: 1px solid $border-light;
      border-right: none;
    }

    .rooms-grid {
      flex: 1;
      display: grid;
      grid-template-columns: repeat(4, 1fr); // 响应式网格，一排4个
      gap: 8px;
      padding: 8px;
      border: 1px solid $border-light;
    }
  }

  /* 房间卡片样式定义 */
  .room-card {
    height: 70px;
    padding: 8px;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    border: 1px solid transparent;

    .room-no {
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 4px;
    }
    .room-info {
      font-size: 10px;
      transform: scale(0.9);
      line-height: 1.2;
    }

    /* 状态颜色应用 */
    &.status-rented {
      background-color: $color-rented;
      color: #fff;
    }
    &.status-vacant {
      background-color: #fff;
      border-color: #dcdfe6;
      color: #606266;
      .room-no {
        color: #52c41a;
      } // 图片中空置的编号似乎也是绿色或者黑色，这里保持细节
    }
    &.status-reserved {
      background-color: #fff;
      border-color: $color-reserved;
      color: $color-reserved;
    }
    &.status-decorating {
      background-color: $color-decorating;
      color: #fff;
    }
    &.status-expiring {
      background-color: $color-expiring;
      color: #fff;
    }

    &:hover {
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      opacity: 0.9;
    }
  }
}

/* 弹出框内容样式 */
.pop-content {
  font-size: 12px;
  line-height: 1.8;
  p {
    margin: 0;
    color: #333;
  }
}

/* 响应式适配：移动端减小列数 */
@media (max-width: 992px) {
  .rent-control-container .floor-row .rooms-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>

<style>
/* 全局样式覆盖 Element UI */
.room-popover {
  background: rgba(0, 0, 0, 0.8) !important;
  color: #fff !important;
  border: none !important;
  padding: 10px !important;
}
.room-popover .pop-content p {
  color: #fff !important;
}
.room-popover .popper__arrow::after {
  border-right-color: rgba(0, 0, 0, 0.8) !important;
}

::v-deep .rent-control-container .tabs-header {
  text-align: left !important;
  /* border: 1px solid red; */
}
::v-deep .tabs-header {
  text-align: left !important;
  /* border: 1px solid red; */
}
</style>